export const Maladzyechna = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.46270562631895, 54.28785121184194],
            [26.46563857690603, 54.28036066613822],
            [26.469209706248876, 54.27384485406526],
            [26.47010248880929, 54.26915283162282],
            [26.473673618152077, 54.264720986435634],
            [26.477691138325895, 54.26211379584885],
            [26.484833397011528, 54.2605494025637],
            [26.495546784141652, 54.2605494025637],
            [26.506706563001046, 54.2605494025637],
            [26.51652716846928, 54.25950644090483],
            [26.52188386203443, 54.25950644090483],
            [26.529472511551035, 54.25898494991981],
            [26.538400335357153, 54.25637739711044],
            [26.543310638091327, 54.2550735586089],
            [26.550899287607933, 54.25324811534517],
            [26.55848793712454, 54.25220496900607],
            [26.561612674738114, 54.250640199764234],
            [26.563398239858543, 54.24568470516289],
            [26.56116628390714, 54.24177205233059],
            [26.55491680778175, 54.23733726316732],
            [26.54598898487376, 54.23446744052097],
            [26.537061161965937, 54.23055372337592],
            [26.529472511551035, 54.22690058618832],
            [26.525454991377273, 54.22142027447438],
            [26.525454991377273, 54.217766329006395],
            [26.524115817985887, 54.21150167000542],
            [26.52277664459467, 54.207846846878624],
            [26.52277664459467, 54.20393060629863],
            [26.52724055649776, 54.20027511331119],
            [26.532150859231933, 54.20027511331119],
            [26.538846726188126, 54.198969501614215],
            [26.54554259314449, 54.19531356972084],
            [26.551345678438906, 54.194007801267105],
            [26.55804154539527, 54.19087378908398],
            [26.569647715983933, 54.18695593969045],
            [26.574111626988895, 54.187217141026565],
            [26.5817002765055, 54.18852312400418],
            [26.587056970070478, 54.19035143044249],
            [26.59152088197368, 54.192440824878474],
            [26.596877575538656, 54.19426895857339],
            [26.60491261678453, 54.19557471825118],
            [26.611608483740895, 54.19557471825118],
            [26.61919713325767, 54.195052419540616],
            [26.622321871769543, 54.19191848603907],
            [26.622768262600516, 54.189045505748595],
            [26.622768262600516, 54.18564990720512],
            [26.625000218551918, 54.18225402976259],
            [26.63169608550828, 54.18147032621022],
            [26.637499170802755, 54.1825152613298],
            [26.639284735024887, 54.18669473617865],
            [26.6401775175853, 54.189045505748595],
            [26.64642699371052, 54.1932243204983],
            [26.65044451388451, 54.1932243204983],
            [26.65758677257014, 54.191134965666606],
            [26.658479554232088, 54.187739539273366],
            [26.657140380840872, 54.184605051301276],
            [26.655354816618512, 54.18120908856713],
            [26.654015643227297, 54.1759839854422],
            [26.658479554232088, 54.17337118604814],
            [26.66294346613512, 54.17337118604814],
            [26.66606820464699, 54.17624525609352],
            [26.67187128904311, 54.17911912643223],
            [26.674996027554926, 54.17911912643223],
            [26.679906330288986, 54.17885787393578],
            [26.68437024129372, 54.17624525609352],
            [26.68660219724535, 54.173632473204464],
            [26.687494979805535, 54.17128082780039],
            [26.68883415319692, 54.17023560932614],
            [26.69285167337074, 54.17023560932614],
            [26.696422802713528, 54.17049691628904],
            [26.698654758665157, 54.174416325822165],
            [26.700440322887346, 54.17702905867088],
            [26.704904234790376, 54.17833536346569],
            [26.708028972403895, 54.17729032272041],
            [26.711153710915767, 54.174416325822165],
            [26.711153710915767, 54.169190363916584],
            [26.715171231089528, 54.16474777760391],
            [26.715171231089528, 54.157952311180566],
            [26.714278448529342, 54.1524628506898],
            [26.712492884307153, 54.14958712826922],
            [26.709814536626254, 54.147234115499884],
            [26.70535062562135, 54.14383508411589],
            [26.70713618984371, 54.1404357731717],
            [26.71383205769837, 54.13860525975514],
            [26.718742360432373, 54.1393897754873],
            [26.725438227388736, 54.14174323352091],
            [26.731241312683153, 54.142004720426826],
            [26.73882996219976, 54.13991277789489],
            [26.743740264933763, 54.137820729162456],
            [26.750436131890126, 54.13808224083573],
            [26.756685608015516, 54.13468245765523],
            [26.755346434624357, 54.128666773459656],
            [26.750436131890126, 54.12448143421631],
            [26.74284748237352, 54.12081891570489],
            [26.733026876905342, 54.11977242261577],
            [26.724991836557763, 54.11872590310202],
            [26.718742360432373, 54.11401623695872],
            [26.721420707214975, 54.11009110682812],
            [26.730794920953883, 54.107212441693775],
            [26.74463304659588, 54.105903891374794],
            [26.753114478672728, 54.105903891374794],
            [26.758024781406903, 54.10354839705275],
            [26.76025673735836, 54.100407529822235],
            [26.76204230158072, 54.09569578243054],
            [26.771416516217755, 54.093339708281405],
            [26.777219600613876, 54.09412508119942],
            [26.781683512516963, 54.096742883895615],
            [26.78480825013048, 54.09988402864849],
            [26.788379379473326, 54.10354839705275],
            [26.795968028989932, 54.10485702170331],
            [26.800878331724107, 54.10407185197391],
            [26.81427006653513, 54.10197799317149],
            [26.819180369269134, 54.10197799317149],
            [26.824537062834338, 54.10093102386185],
            [26.83301849491113, 54.097004654868556],
            [26.836143232524705, 54.092292521437685],
            [26.839714361867493, 54.08653251998095],
            [26.8499813581667, 54.08260478749713],
            [26.863373092977724, 54.08155732969948],
            [26.870515351663357, 54.08260478749713],
            [26.876318436059478, 54.086008843689626],
            [26.87765761034899, 54.089412620662756],
            [26.87765761034899, 54.09543400319757],
            [26.879889565402323, 54.09857524706831],
            [26.883780668361055, 54.10089542653958],
            [26.888168872048595, 54.101217058647364],
            [26.892922759227076, 54.102396354333564],
            [26.89603106934908, 54.10411163432201],
            [26.898042329896555, 54.106684420227566],
            [26.90060211523138, 54.1099001790605],
            [26.903527584056917, 54.11225824306234],
            [26.907915787744457, 54.11354440349987],
            [26.911755465746523, 54.1139731151294],
            [26.915777985943294, 54.1139731151294],
            [26.92017636754298, 54.114310607066386],
            [26.92366379815593, 54.11267519247258],
            [26.927848714891184, 54.10776856315357],
            [26.930638659381543, 54.10327030895496],
            [26.934823577015322, 54.098362566068545],
            [26.939008493750805, 54.095090415184075],
            [26.95295821710056, 54.09222707141544],
            [26.959933079224527, 54.092636132625046],
            [26.9669079404502, 54.09386329205438],
            [26.973185316451747, 54.09549944816064],
            [26.980857663799952, 54.097135539735575],
            [26.992017442659403, 54.097135539735575],
            [27.00108476315114, 54.09590847710416],
            [27.005967166907453, 54.09590847710416],
            [27.017824431889437, 54.09549944816064],
            [27.02410180699269, 54.09549944816064],
            [27.035959071974673, 54.09549944816064],
            [27.04223644797605, 54.095090415184075],
            [27.05548868520333, 54.09018170433865],
            [27.062463546428944, 54.08690890811795],
            [27.0743208114111, 54.08322670327044],
            [27.082690645780133, 54.08281754928845],
            [27.096640369129943, 54.08036254068526],
            [27.10849763411187, 54.0799533584663],
            [27.11547249623601, 54.079544172213275],
            [27.117564954603665, 54.0754520872851],
            [27.116867468481132, 54.07176886640519],
            [27.11547249623601, 54.06726670769319],
            [27.112682550847353, 54.064810779287654],
            [27.110590092479697, 54.06112661381326],
            [27.11477500921518, 54.059489102265786],
            [27.126632274197163, 54.06194534537798],
            [27.13500210856637, 54.0652201107751],
            [27.143371942935403, 54.068903912606004],
            [27.150346804161245, 54.07217812930662],
            [27.157321666285213, 54.081999229222845],
            [27.158019152407746, 54.08690890811795],
            [27.160809096898106, 54.08936352948473],
            [27.165691500654418, 54.08936352948473],
            [27.1698764173899, 54.086090668727024],
            [27.1698764173899, 54.0799533584663],
            [27.170573903512434, 54.07381514056948],
            [27.168999612811774, 54.068272428941896],
            [27.17545630637045, 54.068903912606004],
            [27.181733682371828, 54.06972249085561],
            [27.185221112984777, 54.0754520872851],
            [27.187313571352377, 54.08036254068526],
            [27.197775864089294, 54.08486327886101],
            [27.20893564294869, 54.086090668727024],
            [27.21939793568572, 54.08731802176294],
            [27.228465256177344, 54.089772618928464],
            [27.230557714544943, 54.097135539735575],
            [27.22707028393222, 54.10163445936246],
            [27.22707028393222, 54.10776856315357],
            [27.22707028393222, 54.11226632887485],
            [27.22986022842258, 54.11676360719724],
            [27.236835089648253, 54.12085161869828],
            [27.25078481389636, 54.12493922646826],
            [27.262642078878287, 54.127391597600024],
            [27.270314426226662, 54.12902643157929],
            [27.279381746718286, 54.12984382411554],
            [27.289146553332614, 54.130252514336235],
            [27.297516386803522, 54.13066120052548],
            [27.302398790559835, 54.13270457099742],
            [27.305188735050024, 54.136791010108254],
            [27.30449124892749, 54.14128562693611],
            [27.299608846069475, 54.1429199126473],
            [27.29681890068099, 54.14700534344132],
            [27.2961214145584, 54.152315801393286],
            [27.2961214145584, 54.155991872888876],
            [27.30100381831471, 54.1588508144298],
            [27.305188735050024, 54.16089279424614],
            [27.307978679540383, 54.16456810454133],
            [27.309424986910756, 54.16858410977267],
            [27.313138961858442, 54.17276499317336],
            [27.322281052724634, 54.176443821105465],
            [27.33142314269236, 54.17978792572336],
            [27.336851259509046, 54.182964575176186],
            [27.33485142732866, 54.187645507750176],
            [27.32942331051197, 54.19149016359137],
            [27.32570933646241, 54.19533446187427],
            [27.325423646151023, 54.19884416061194],
            [27.330851762069358, 54.200849569453055],
            [27.334280046705658, 54.20369039797288],
            [27.335994188574603, 54.207700647437605],
            [27.336565569197603, 54.21338116763974],
            [27.336851259509046, 54.21588703092391],
            [27.34113661418138, 54.221232364985326],
            [27.348278872867013, 54.22240156446463],
            [27.352849918749257, 54.227078031833],
            [27.353421299372258, 54.232087944746866],
            [27.353992679995258, 54.237598146620996],
            [27.353992679995258, 54.243915953560474],
            [27.34913594380157, 54.242272892580615],
            [27.34399351819468, 54.24010254039678],
            [27.336279878886046, 54.23859992237101],
            [27.328566239577412, 54.2380990375359],
            [27.322566743036077, 54.23976863000871],
            [27.319138458399777, 54.241271205475925],
            [27.31656724559639, 54.24327455484183],
            [27.308567915976198, 54.246279395717295],
            [27.30342549036942, 54.247948657716165],
            [27.298283063864176, 54.2491171005575],
            [27.291997877011283, 54.249951682322944],
            [27.28485561832565, 54.24961785164322],
            [27.276570598394017, 54.24828250190524],
            [27.26971403001994, 54.24678018125212],
            [27.26457160441305, 54.24544473964983],
            [27.260857629465363, 54.244777002637136],
            [27.25542951354703, 54.244443130077855],
            [27.25057277735334, 54.244443130077855],
            [27.24628742268078, 54.244943937903486],
            [27.242573448631447, 54.247114034897834],
            [27.24000223492976, 54.250619335577426],
            [27.23885947368376, 54.254458132590855],
            [27.235431189945814, 54.259798472996465],
            [27.232288596519425, 54.2644707030754],
            [27.23028876344057, 54.26864189018647],
            [27.22886031188318, 54.27281265523129],
            [27.22828893126018, 54.27448084286573],
            [27.229431692506182, 54.279985383493795],
            [27.230574453752126, 54.28198685212999],
            [27.232859977142425, 54.2841550006234],
            [27.24000223492976, 54.28782391416564],
            [27.24685880330378, 54.290658760431086],
            [27.25228692012047, 54.29366014913791],
            [27.254572442612414, 54.29732821659053],
            [27.253429681366413, 54.30166278405477],
            [27.25114415797617, 54.30483006362073],
            [27.248572945172782, 54.306496955511705],
            [27.238573783372203, 54.307497057931414],
            [27.2345741190112, 54.30633026888847],
            [27.23086014406357, 54.304163288173584],
            [27.22886031188318, 54.30132937203007],
            [27.226860479702623, 54.29849526027374],
            [27.22600340876818, 54.29649459370728],
            [27.221718054095845, 54.29432709470103],
            [27.2177183888366, 54.29382688654135],
            [27.211147511672266, 54.29315993287696],
            [27.199719897415946, 54.29315993287696],
            [27.194006091185997, 54.293326672305625],
            [27.186863832500364, 54.29366014913791],
            [27.18086433595903, 54.2946605634321],
            [27.174864838519397, 54.29632786710533],
            [27.169722412014153, 54.297661661018196],
            [27.162580154226816, 54.2991621275271],
            [27.15743772772157, 54.301162665005165],
            [27.151723921491794, 54.303163104752],
            [27.14601011436355, 54.305496828267565],
            [27.140867688756657, 54.307163693158145],
            [27.134582501005582, 54.30783042000468],
            [27.129154384188723, 54.3084971360513],
            [27.124583339205003, 54.30933051592217],
            [27.120869365155613, 54.31033054949302],
            [27.114584177404367, 54.31099722504064],
            [27.109156060587736, 54.31099722504064],
            [27.1025851834234, 54.31016387891856],
            [27.09715706660654, 54.30949718987148],
            [27.08972911850782, 54.3096638631456],
            [27.084586692002574, 54.30983053574488],
            [27.080872717953184, 54.31116389223996],
            [27.078015813939942, 54.31349716268562],
            [27.075444601136553, 54.31683017594855],
            [27.073444768956165, 54.31932975925156],
            [27.072016317398607, 54.323995240817226],
            [27.069159414283604, 54.3261611779285],
            [27.064302678089973, 54.32816040278175],
            [27.059731633106026, 54.330159530982655],
            [27.05773180002734, 54.33232514297498],
            [27.056874729092726, 54.334324068209355],
            [27.056874729092726, 54.336322896798606],
            [27.057446109715727, 54.33815507050008],
            [27.060303013729026, 54.34248533885585],
            [27.060303013729026, 54.3448168326118],
            [27.05773180002734, 54.35014546514594],
            [27.05344644535495, 54.35397499320294],
            [27.054874896912338, 54.359801850883],
            [27.052589374420393, 54.36363047849369],
            [27.050589542240004, 54.36446274162461],
            [27.046875567292318, 54.368290935349876],
            [27.04716125760376, 54.3709538158235],
            [27.049161090682446, 54.376611864041536],
            [27.048875400371003, 54.37894142229237],
            [27.046304186669317, 54.381270847831956],
            [27.04287590293137, 54.38176999324992],
            [27.038876238570424, 54.38077169634414],
            [27.033448121753793, 54.377610262634676],
            [27.031448289573177, 54.37561344169177],
            [27.027734314625548, 54.37394935048525],
            [27.02059205683821, 54.3742821741223],
            [27.01344979815258, 54.374614995061336],
            [27.007164610401503, 54.374614995061336],
            [26.996594067977924, 54.37528062884604],
            [26.988880429567587, 54.376112655901636],
            [26.983452312750956, 54.37644546200272],
            [26.973738841261763, 54.37677826540602],
            [26.964596750395742, 54.376611864041536],
            [26.957168801398495, 54.37594625183954],
            [26.948312401742214, 54.37411576264111],
            [26.941741523679582, 54.37245161073258],
            [26.936313406862894, 54.3716195094853],
            [26.928885458764, 54.371286663741785],
            [26.921171819455537, 54.3714530866892],
            [26.91174403827779, 54.37245161073258],
            [26.904316089280712, 54.37278444650997],
            [26.89517399841452, 54.37311727958968],
            [26.887746050315798, 54.37345010997126],
            [26.882603623810553, 54.37478140451924],
            [26.873461532944532, 54.38143723031237],
            [26.86917617827214, 54.38360014171025],
            [26.86003408740595, 54.383267393086214],
            [26.85317751903193, 54.3821027534899],
            [26.844892499100297, 54.38010615158544],
            [26.839178692870348, 54.37844224247897],
            [26.834036266365104, 54.3779430565956],
            [26.830036602004327, 54.381270847831956],
            [26.83032229231577, 54.38526384175111],
            [26.831750743873158, 54.38842468603838],
            [26.835750408234105, 54.391086261352825],
            [26.840035763804735, 54.392416984012186],
            [26.84774940311337, 54.394080326647725],
            [26.854320280277705, 54.39624257178798],
            [26.86203391958651, 54.40040041422827],
            [26.86431944207834, 54.403227506899725],
            [26.863462371143896, 54.40671952818201],
            [26.86003408740595, 54.410044986834464],
            [26.84946354498237, 54.4147001756923],
            [26.844321118477296, 54.41686133347304],
            [26.836321789755402, 54.41918860727304],
            [26.83032229231577, 54.41968729149954],
            [26.819466059580748, 54.41819122009588],
            [26.813752252452502, 54.415863890192554],
            [26.809181207468555, 54.41386893082506],
            [26.801603717722855, 54.41331822185185],
            [26.798116287109906, 54.41291232846436],
            [26.786956508250512, 54.41291232846436],
            [26.774401757145824, 54.41169462576033],
            [26.768124381144446, 54.410070965898115],
            [26.763939464408963, 54.409665040886466],
            [26.75487214391717, 54.40763535555169],
            [26.746502309548134, 54.40519960001484],
            [26.74161990669012, 54.40398166825639],
            [26.73185510007579, 54.40357568296599],
            [26.72418275182912, 54.40357568296599],
            [26.71581291835838, 54.40641749612843],
            [26.708838056234242, 54.41047688689116],
            [26.69837576349738, 54.414535876336515],
            [26.68233358177997, 54.41900030004882],
            [26.669778830675284, 54.42346423810642],
            [26.653669330156845, 54.42554691942979],
            [26.653356179843854, 54.42509149717489],
            [26.6453067780854, 54.41780637796211],
            [26.63367986603305, 54.413122402976626],
            [26.621158574608558, 54.4042734355707],
            [26.606848528037176, 54.40010855376681],
            [26.58717221422637, 54.39698461564757],
            [26.56928465556257, 54.39125677777815],
            [26.55944649865711, 54.3824030916295],
            [26.54603083055855, 54.370421534626246],
            [26.539770184846304, 54.36156335366593],
            [26.533509539134002, 54.353745725185206],
            [26.530826405514233, 54.34540528122892],
            [26.520093871035442, 54.336020259427414],
            [26.51115009080422, 54.33184845014591],
            [26.501311934798082, 54.325068357818566],
            [26.503100690844292, 54.318287147633896],
            [26.501311934798082, 54.30993950910113],
            [26.495945666659225, 54.3021120591244],
            [26.49236815546618, 54.297414874896674],
            [26.479846864940896, 54.29167314430026],
            [26.468219951089964, 54.28854095310248],
            [26.46270562631895, 54.28785121184194],
          ],
        ],
      },
      properties: {
        shapeName: "Maladzyechna",
        shapeISO: "",
        shapeID: "67162791B22380901430791",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
